<!-- eslint-disable max-len -->
<template>
  <div class="ac-card-content deactivate-member-container">
    <div class="ac-header-container">
      <div class="ac-header">
        Deactivate Member
      </div>
      <button
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div class="title">
        Are you sure you want to deactivate this member?
      </div>
      <div class="sub-title">
        When deactivated, the member's access is temporarily suspended, preventing login and usage until reactivated.
      </div>
      <div>
        <span class="underline">Please note</span>: You can reactivate a member anytime.
      </div>
      <div class="title">
        Reason for Deactivation
      </div>
      <SACDropdown
        field="selectedReason"
        :options="reasonOptions"
        :value="selectedReason"
        :change="onChange"
        placeholder="Select a reason"
        :error="errObj.reasonErr"
      />
      <div class="de-input-container">
        <SACInput
          type="textarea"
          field="notes"
          placeholder="Any additional note"
          :value="notes"
          :change="onChange"
          :max="100"
        />
        <div class="de-count-container">
          {{ notes.length }}/100
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-cancel-button-two"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        class="ac-form-button"
        @click="deactivateMember"
      >
        Yes
      </button>
    </div>
    <ProcessOverlay
      :show="processing"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import SACInput from '@shared/components/sac/SACInput.vue';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'DeactivateMember',
  components: {
    ProcessOverlay,
    SACInput,
    SACDropdown,
  },
  mixins: [customerDetailMixin],
  data() {
    return {
      selectedReason: '',
      notes: '',
      reasonOptions: [{
        label: 'Non Payment',
        value: 'Non Payment',
      }, {
        label: 'Moved',
        value: 'Moved',
      }, {
        label: 'Poor Experience',
        value: 'Poor Experience',
      }, {
        label: 'Other',
        value: 'Other',
      }],
      processing: false,
      errObj: {},
    };
  },
  methods: {
    onChange(field, value) {
      this[field] = value;
    },
    async deactivateMember() {
      const {
        corporationId,
      } = this.customer;
      const error = {};
      if (!this.selectedReason) {
        error.reasonErr = 'Please select a reason.';
      }
      this.errObj = error;
      if (Object.keys(error).length === 0) {
        this.processing = true;
        try {
          let cancelReason = this.selectedReason;
          if (this.notes.length > 0) {
            cancelReason += ` - ${this.notes}`;
          }
          if (corporationId === 1) {
            await this.$store.dispatch('cancelSubscription', cancelReason);
          } else {
            await this.$store.dispatch('deactivateCustomer', cancelReason);
          }
          await this.toggleActionModal(false);
          this.$store.dispatch('showSuccessToast', {
            header: 'Member deactivation.',
            message: `${this.customer.firstName} ${this.customer.lastName} was successfully deactivated`,
          });
          await Promise.all([
            this.$store.dispatch('getAllCustomers'),
            this.$store.dispatch('getPartnerCustomerCount'),
            this.$store.dispatch('getAllDeactivatedCustomers'),
          ]);
        } catch (err) {
          console.error(err);
          this.$store.dispatch('showAlertToast', {
            header: 'There was an unexepected error deactivating member.',
            message: 'Please try again or contact support',
          });
        }
        this.processing = false;
      }
    },
  },
};
</script>

<style lang="scss">

.deactivate-member-container {
  .title {
    padding-top: 10px;
    font-weight: 600;
  }

  .sub-title {
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .underline {
    text-decoration: underline;
  }

  .de-input-container {
    flex: 1;
    position: relative;
    margin-top: 18px;

    .de-count-container {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      text-align: right;
      padding: 0 8px 8px 0;
      font-size: 0.75rem;
      color: $N40;
    }
  }

  #sac-input-container {
    height: 100%;
  }

  .sac-textarea {
    flex: 1;
  }
}
</style>
